import {
  Integration,
  IntegrationEnum,
} from 'models/InternalIntegrationSetting';
import { useNavigate } from 'react-router-dom';
import useIntegrationsActiveTab from '../useIntegrationsActiveTab';

const useRedirectToIntegrationDetails = () => {
  const navigate = useNavigate();
  const activeTab = useIntegrationsActiveTab();

  const redirectToIntegrationDetails = ({
    enumId,
    allowedForAgencyOnly,
  }: Integration) => {
    const currentPageHref = `#/integrations/${activeTab}`;

    // For Zapier, redirect to templates page
    if (enumId === IntegrationEnum.ZAPIER) {
      navigate('/integrations/details/zapier/templates', {
        state: { from: currentPageHref },
      });
      return;
    }

    // The integration does not have details page
    if (allowedForAgencyOnly) {
      return;
    }

    navigate(`/integrations/details/${enumId}`, {
      state: { from: currentPageHref },
    });
  };

  return {
    redirectToIntegrationDetails,
  };
};

export default useRedirectToIntegrationDetails;
